import { PlusOne } from '@mui/icons-material';
import { RoutalPalette, RoutalSelect } from '@nx-smartmonkey/ui';
import React, { useState } from 'react';

import AddStopIcon from '../../assets/svg/Plan/overview/AddStopIcon';
import { DataImporter } from '../../pages/planner/plan-details/dialogs/data-importer';
import { StopsFromClientsDialog } from '../../pages/planner/plan-details/dialogs/StopsFromClientsDialog';
import { StopsFromFileDialog } from '../../pages/planner/plan-details/dialogs/StopsFromFileDialog';
import { StopsFromScratchDialog } from '../../pages/planner/plan-details/dialogs/StopsFromScratchDialog';
import Text from '../../react-components/Text';

type IconStopsCreateMenuProps = {
  id: string;
  style?: React.CSSProperties;
};

export const IconStopsCreateMenu = ({ id, style }: IconStopsCreateMenuProps) => {
  const [dialog, setDialog] = useState<
    `stopsFromScratch` | `stopsFromClients` | `stopsFromFile` | `stopsFromFileV1` | undefined
  >(undefined);
  const [isHover, setIsHover] = useState<boolean>(false);

  const importStopsVersion = localStorage.getItem(`VERSION_OF_IMPORT_STOPS`) || `v2`;

  return (
    <>
      <RoutalSelect
        id={id}
        hideSeparator
        style={{
          border: `1px solid ${isHover ? RoutalPalette.secondary20 : RoutalPalette.secondary60}`,
          backgroundColor: isHover ? RoutalPalette.neutral05 : RoutalPalette.neutral00,
          borderRadius: `10px`,
          ...style,
        }}
        containerStyle={{
          width: `unset`,
        }}
        arrowStyle={{ color: isHover ? RoutalPalette.secondary20 : RoutalPalette.secondary60 }}
        icon={<PlusOne />}
        popoverProps={{
          options: [
            {
              key: `from_scratch`,
              onClick: () => setDialog(`stopsFromScratch`),
              content: <Text intlId="plans.create_stop_from_scratch" style={{ cursor: `pointer` }} />,
            },
            {
              key: `from_clients`,
              onClick: () => setDialog(`stopsFromClients`),
              content: <Text intlId="plans.create_from_clients" style={{ cursor: `pointer` }} />,
            },
            {
              key: `upload_excel`,
              onClick: () => setDialog(importStopsVersion === `v2` ? `stopsFromFile` : `stopsFromFileV1`),
              content: <Text intlId="plans.upload_excel" style={{ cursor: `pointer` }} />,
            },
          ],
        }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <AddStopIcon color={isHover ? RoutalPalette.secondary20 : RoutalPalette.secondary60} />
      </RoutalSelect>

      <StopsFromScratchDialog
        open={Boolean(dialog === `stopsFromScratch`)}
        handleCloseDialog={(e: any) => {
          e.stopPropagation();
          setDialog(undefined);
        }}
      />

      <StopsFromClientsDialog
        open={Boolean(dialog === `stopsFromClients`)}
        handleCloseDialog={(e: any) => {
          if (e) e.stopPropagation();
          setDialog(undefined);
        }}
      />

      <DataImporter
        open={Boolean(dialog === `stopsFromFile`)}
        handleCloseDialog={(e: any) => {
          if (e) e.stopPropagation();
          setDialog(undefined);
        }}
        onComplete={() => {
          setDialog(undefined);
        }}
        onSelectOldVersion={(e: any) => {
          if (e) e.stopPropagation();
          localStorage.setItem(`VERSION_OF_IMPORT_STOPS`, `v1`);
          setDialog(`stopsFromFileV1`);
        }}
      />

      <StopsFromFileDialog
        open={Boolean(dialog === `stopsFromFileV1`)}
        handleCloseDialog={(e: any) => {
          e.stopPropagation();
          setDialog(undefined);
        }}
        onSelectNewVersion={(e: any) => {
          e.stopPropagation();
          localStorage.setItem(`VERSION_OF_IMPORT_STOPS`, `v2`);
          setDialog(`stopsFromFile`);
        }}
      />
    </>
  );
};
